import styled from 'styled-components';
import { device } from '../breakpoints';
import { PlayLinkContainer } from '../../components/Link';
import { ClearFix } from '../utils.styles';
import { regularOutline } from '../typography/helpers';
import { regularWhite, fontWeightRegular } from '../design-tokens';
import PlayText from '../typography/PlayText/PlayText';

export const StyledCircleLink = styled.li`
    margin-bottom: 10px;

    @media ${device.GteSmall} {
        width: 50%;
        display: inline-block;
    }

    @media ${device.GteMedium} {
        width: 25%;
    }

    &:focus {
        outline: none;
    }
`;

export const Figure = styled.figure`
    position: relative;
    float: left;
    display: block;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    overflow: hidden;
    z-index: 10;
    margin: 0;

    @media ${device.GteSmall} {
        width: 50px;
        height: 50px;
    }

    @media ${device.GteMedium} {
        width: 55px;
        height: 55px;
    }

    @media ${device.GteLarge} {
        width: 60px;
        height: 60px;
    }
`;

export const RelatedTitle = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 10px 8px 0 0;
    padding-left: 10px;

    @media ${device.GteSmall} {
        margin-top: 17px;
    }
`;

export const RelatedTitleSpan = styled(PlayText)`
    color: ${regularWhite};
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${fontWeightRegular};
`;

export const Link = styled(PlayLinkContainer)`
    ${ClearFix};
    display: block;
    text-decoration: none;
    padding: 5px 5px 1px;

    &:focus {
        ${regularOutline()}
    }

    &:hover {
        cursor: pointer;
        ${Figure} {
            filter: brightness(120%) grayscale(40%) contrast(60%);
            transition: all 0.1s linear;
        }

        ${RelatedTitleSpan} {
            text-decoration: underline;
        }
    }
`;
